import Vue from 'vue'
import App from './App.vue'
import VueAMap from 'vue-amap' // 地图
import ELEMENTUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.less'

// @ src的绝对路径 在vue-cli的项目中才可使用
// 目录的默认索引文件  index文件  .js .vue .json 优先级按照现在的顺序
import router from '@/router'

import axios from 'axios'

import store from './store'
import global from './api/global'
import rules from './utils/rules'
import VueRouter from 'vue-router'

import 'font-awesome/css/font-awesome.css'

import Print from '@/utils/print'
import PrintS from 'vue-print-nb'

// 引入echarts
import echarts from 'echarts' //  注册
import 'echarts/map/js/world.js'
import 'echarts/map/js/china.js'
import 'echarts/extension-src/bmap/bmap.js'
// import 'echarts-gl' // 制作3D图 数据可视化相关图表时需引入
// import 'echarts/lib/component/visualMap' // 按需引入
import scroll from 'vue-seamless-scroll/src'
import VueQriously from 'vue-qriously' // 生成二维码插件
import preview from 'vue-photo-preview' // 点击图片放大
import LightTimeline from 'vue-light-timeline' // 时间轴
import 'vue-photo-preview/dist/skin.css'
import PrintE from '@/utils/printE'
import { post } from './api/http'
import unUsual from '@/components/unUsual'
Vue.component('UnUsual', unUsual)
Vue.use(preview)
Vue.use(VueQriously)
Vue.use(LightTimeline)// 时间轴
Vue.use(scroll)
Vue.use(PrintS) // 注册
Vue.use(Print)
Vue.prototype.$echarts = echarts
Vue.use(PrintE)
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location) {
  return routerPush.call(this, location).catch(error => error)
}
Vue.prototype.$post = post
const { create, all } = require('mathjs')
const config = {
  number: 'BigNumber',
  precision: 20
}
const math = create(all, config)

Vue.prototype.$math = math
Vue.prototype.global = global
Vue.prototype.rule = rules

Vue.prototype.$axios = axios // 全局注册，使用方法为:this.$axios

Vue.use(ELEMENTUI)

Vue.config.productionTip = false

Vue.filter('dateFormat', function (data) {
  // msg 为固定的参数 即是你需要过滤的数据
  var t = new Date(data) // row 表示一行数据, transferTime 表示要格式化的字段名称
  var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  var hour = t.getHours() < 10 ? '0' + t.getHours() : t.getHours()
  var minutes = t.getMinutes() < 10 ? '0' + t.getMinutes() : t.getMinutes()
  var seconds = t.getSeconds() < 10 ? '0' + t.getSeconds() : t.getSeconds()
  var str = ''
  if (data == null || data == '') {
    str = '--'
  } else {
    str =
      t.getFullYear() +
      '-' +
      month +
      '-' +
      date +
      ' ' +
      hour +
      ':' +
      minutes +
      ':' +
      seconds
  }
  return str
})
Vue.filter('dateFormat1', function (data) {
  // msg 为固定的参数 即是你需要过滤的数据
  var t = new Date(data) // row 表示一行数据, transferTime 表示要格式化的字段名称
  var month =
    t.getMonth() + 1 < 10 ? '0' + (t.getMonth() + 1) : t.getMonth() + 1
  var date = t.getDate() < 10 ? '0' + t.getDate() : t.getDate()
  var str = ''
  if (data == null || data == '') {
    str = '--'
  } else {
    str =
      t.getFullYear() +
      '-' +
      month +
      '-' +
      date
  }
  return str
})
Vue.filter('numFormat', function (num, n) {
  var result = parseFloat(num)
  let str = ''
  if (isNaN(result)) {
    str = '-'
  } else {
    let a = Math.pow(10, n)
    result = Math.round(num * a) / a
    var s_x = result.toString()
    var pos_decimal = s_x.indexOf('.')
    if (pos_decimal < 0) {
      pos_decimal = s_x.length
      s_x += '.'
    }
    while (s_x.length <= pos_decimal + n) {
      s_x += '0'
    }
    str = s_x
  }

  return str
})
// main.js 是入口文件，职责：
// 1. 所有的全局依赖的包 文件 导入
// 2. 创建vue根实例
// App.vue 根组件
// 处理时间

function onInput (el, ele, binding, vnode) {
  function handle () {
    let val = ele.value
    // modifiers为修饰符对象，传入了float，则其float属性为true
    if (binding.modifiers.float) {
      // 清除"数字"和"."以外的字符
      val = val.replace(/[^\d.]/g, '')
      // 只保留第一个, 清除多余的
      val = val.replace(/\.{2,}/g, '.')
      val = val.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
      // 第一个字符如果是.号，则补充前缀0
      val = val.replace(/^\./g, '0.')
      if (typeof binding.value !== 'undefined') {
        // 期望保留的最大小数位数
        let pointKeep = 0
        if (
          typeof binding.value === 'string' ||
          typeof binding.value === 'number'
        ) {
          pointKeep = parseInt(binding.value)
        }
        if (!isNaN(pointKeep)) {
          if (!Number.isInteger(pointKeep) || pointKeep < 0) {
            pointKeep = 0
          }
          // eslint-disable-next-line no-useless-escape
          const str = '^(\\d+)\\.(\\d{' + pointKeep + '}).*$'
          const reg = new RegExp(str)
          if (pointKeep === 0) {
            // 不需要小数点
            val = val.replace(reg, '$1')
          } else {
            // 通过正则保留小数点后指定的位数
            val = val.replace(reg, '$1.$2')
          }
        }
      } else {
        val = ele.value.replace(/[^\d]/g, '')
      }
      ele.value = val
    }
    if (vnode.componentInstance) {
      vnode.componentInstance.$emit('input', ele.value)
    } else {
      vnode.elm.dispatchEvent(new CustomEvent('input', ele.value))
    }
  }
  return handle
}
const numberInput = {
  bind (el, binding, vnode) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector('input')
    ele.addEventListener('input', onInput(el, ele, binding, vnode), false)
  }
}
Vue.directive('number-input', numberInput)
Vue.filter('moneyFormat', function (value) {
  if (!value) return '0.00'
  var intPart = Number(value) - Number(value) % 1 // 获取整数部分（这里是windy93的方法）
  var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') // 将整数部分逢三一断

  var floatPart = '.00' // 预定义小数部分
  var value2Array = value.toString().split('.')

  //= 2表示数据有小数位
  if (value2Array.length == 2) {
    floatPart = value2Array[1].toString() // 拿到小数部分

    if (floatPart.length == 1) { // 补0,实际上用不着
      return intPartFormat + '.' + floatPart + '0'
    } else {
      return intPartFormat + '.' + floatPart
    }
  } else {
    return intPartFormat + floatPart
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Vue.use(VueAMap)

// 初始化vue-amap
VueAMap.initAMapApiLoader({
  // 高德key
  key: '2f90de3a44cc7538e088c4fae6d333d5',
  // 插件集合 （插件按需引入）
  plugin: [
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.Scale',
    'AMap.OverView',
    'AMap.ToolBar',
    'AMap.MapType',
    'AMap.PolyEditor',
    'AMap.CircleEditor',
    'AMap.Geolocation',
    'AMap.Geocoder',
    'AMap.ControlBar'
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4',
  uiVersion: '1.0.11'
})
